import NewEditTemplateCollectionBodyOptions from "./components/NewEditTemplateCollectionBodyOptions/NewEditTemplateCollectionBodyOptions"
import NewEditTemplateCollectionBodyTable from "./components/NewEditTemplateCollectionBodyTable/NewEditTemplateCollectionBodyTable"
import './styles.css'

const NewEditTemplateCollectionBody = () => {
    return (
        <div className="new-edit-template-collection-body">
            <NewEditTemplateCollectionBodyOptions />
            <NewEditTemplateCollectionBodyTable />
        </div>
    )
}

export default NewEditTemplateCollectionBody
